var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckoutSecurelyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9h-.75V6.75C14.75 4.13 12.62 2 10 2S5.25 4.13 5.25 6.75V9H4.5C3.67 9 3 9.67 3 10.5v6c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5Zm-3.25 0h-4.5V6.75C7.75 5.51 8.76 4.5 10 4.5s2.25 1.01 2.25 2.25V9Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h20v20H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutSecurelyWhite);
export default __webpack_public_path__ + "static/media/Checkout Securely White.48472f3b8ee2af30c16bec6f523ef7f1.svg";
export { ForwardRef as ReactComponent };